// This file is auto-generated. Do not edit manually.
// Run "npm run -w packages/iconik-api generate" to regenerate.
/** biome-ignore-all lint/complexity/noBannedTypes: some API definitions are unclear */
import { httpMethod } from '../constants';
import type { IconikApiHeaders } from '../types';

export const NotificationsHttpGetWebhooks =
  'NotificationsHttpGetWebhooks' as const;
export const NotificationsHttpPostWebhooks =
  'NotificationsHttpPostWebhooks' as const;
export const NotificationsHttpGetWebhooksByWebhookId =
  'NotificationsHttpGetWebhooksByWebhookId' as const;
export const NotificationsHttpPutWebhooksByWebhookId =
  'NotificationsHttpPutWebhooksByWebhookId' as const;
export const NotificationsHttpDeleteWebhooksByWebhookId =
  'NotificationsHttpDeleteWebhooksByWebhookId' as const;

/**
 * Original schema `WebhookBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/notifications/spec/#model-WebhookBaseSchema}
 */
export interface NotificationsWebhookBaseSchema {
  description?: string;
  last_payload?: string;
  first_failed_at?: string;
  date_created?: string;
  /**
   * Adding a query allows filtering out messages so webhooks will be called only if for messages that match this query.
   */
  query?: string;
  deleted_at?: string;
  /**
   * ID of a particular object you want to subscribe on
   */
  object_id?: string | null;
  /**
   * URL you want to be called when notification is appeared
   */
  url: string;
  status: 'ENABLED' | 'DISABLED' | 'FAILING' | 'DELETED';
  /**
   * Operation of event. Example create, update, delete
   */
  operation?: string | null;
  name?: string;
  /**
   * Define the key-value pairs your third party provider requires here
   */
  headers?: {
    [k: string]: string;
  };
  /**
   * Type of events. Example assets, collections
   */
  event_type: string;
  id: string;
  last_error?: string;
  /**
   * Realm of event. Example entity, contents, acls, metadata
   */
  realm?: string | null;
  date_modified?: string;
}
/**
 * Original schema `WebhookCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/notifications/spec/#model-WebhookCreateSchema}
 */
export interface NotificationsWebhookCreateSchema {
  description?: string;
  last_payload?: string;
  first_failed_at?: string;
  date_created?: string;
  /**
   * Adding a query allows filtering out messages so webhooks will be called only if for messages that match this query.
   */
  query?: string;
  deleted_at?: string;
  /**
   * ID of a particular object you want to subscribe on
   */
  object_id?: string | null;
  /**
   * URL you want to be called when notification is appeared
   */
  url: string;
  status: 'ENABLED' | 'DISABLED' | 'FAILING' | 'DELETED';
  /**
   * Operation of event. Example create, update, delete
   */
  operation?: string | null;
  name?: string;
  /**
   * Define the key-value pairs your third party provider requires here
   */
  headers?: {
    [k: string]: string;
  };
  /**
   * Type of events. Example assets, collections
   */
  event_type: string;
  id?: string;
  last_error?: string;
  /**
   * Realm of event. Example entity, contents, acls, metadata
   */
  realm?: string | null;
  date_modified?: string;
}
/**
 * Original schema `WebhookInternalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/notifications/spec/#model-WebhookInternalSchema}
 */
export interface NotificationsWebhookInternalSchema {
  description?: string;
  last_payload?: string;
  first_failed_at?: string;
  date_created?: string;
  /**
   * Adding a query allows filtering out messages so webhooks will be called only if for messages that match this query.
   */
  query?: string;
  deleted_at?: string;
  /**
   * ID of a particular object you want to subscribe on
   */
  object_id?: string | null;
  /**
   * URL you want to be called when notification is appeared
   */
  url: string;
  status: 'ENABLED' | 'DISABLED' | 'FAILING' | 'DELETED';
  /**
   * Operation of event. Example create, update, delete
   */
  operation?: string | null;
  name?: string;
  headers?: string;
  /**
   * Type of events. Example assets, collections
   */
  event_type: string;
  id: string;
  last_error?: string;
  /**
   * Realm of event. Example entity, contents, acls, metadata
   */
  realm?: string | null;
  date_modified?: string;
}
/**
 * Original schema `WebhookSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/notifications/spec/#model-WebhookSchema}
 */
export interface NotificationsWebhookSchema {
  description?: string;
  last_payload?: string;
  first_failed_at?: string;
  date_created?: string;
  /**
   * Adding a query allows filtering out messages so webhooks will be called only if for messages that match this query.
   */
  query?: string;
  deleted_at?: string;
  /**
   * ID of a particular object you want to subscribe on
   */
  object_id?: string | null;
  /**
   * URL you want to be called when notification is appeared
   */
  url: string;
  status: 'ENABLED' | 'DISABLED' | 'FAILING' | 'DELETED';
  /**
   * Operation of event. Example create, update, delete
   */
  operation?: string | null;
  name?: string;
  /**
   * Define the key-value pairs your third party provider requires here
   */
  headers?: {
    [k: string]: string;
  };
  /**
   * Type of events. Example assets, collections
   */
  event_type: string;
  id: string;
  last_error?: string;
  /**
   * Realm of event. Example entity, contents, acls, metadata
   */
  realm?: string | null;
  date_modified?: string;
}
/**
 * Original schema `WebhooksSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/notifications/spec/#model-WebhooksSchema}
 */
export interface NotificationsWebhooksSchema {
  objects?: NotificationsWebhookSchema[];
}
/**
 * Original schema `WebhooksSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/notifications/spec/#model-WebhooksSchema}
 */
export interface NotificationsWebhooksSchemaWithId {
  objects: NotificationsWebhookSchemaNullable[];
}
/**
 * Original schema `WebhookSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/notifications/spec/#model-WebhookSchema}
 */
export interface NotificationsWebhookSchemaNullable {
  description?: string | null;
  last_payload?: string | null;
  first_failed_at?: string | null;
  date_created?: string | null;
  /**
   * Adding a query allows filtering out messages so webhooks will be called only if for messages that match this query.
   */
  query?: string | null;
  deleted_at?: string | null;
  /**
   * ID of a particular object you want to subscribe on
   */
  object_id?: string | null;
  /**
   * URL you want to be called when notification is appeared
   */
  url: string;
  status: 'ENABLED' | 'DISABLED' | 'FAILING' | 'DELETED';
  /**
   * Operation of event. Example create, update, delete
   */
  operation?: string | null;
  name?: string | null;
  /**
   * Define the key-value pairs your third party provider requires here
   */
  headers?: {
    [k: string]: string;
  } | null;
  /**
   * Type of events. Example assets, collections
   */
  event_type: string;
  id: string;
  last_error?: string | null;
  /**
   * Realm of event. Example entity, contents, acls, metadata
   */
  realm?: string | null;
  date_modified?: string | null;
}

/**
 * `GET /v1/webhooks/`
 *
 * Get all webhooks
 *
 * Required roles:
 *  - can_read_webhooks
 *
 * Responses
 * - 200 - Returns a list of webhooks
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link NotificationsWebhooksSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/notifications/spec/#/default/get_v1_webhooks_}
 */
export const httpGetWebhooks = (headers?: IconikApiHeaders) => ({
  id: NotificationsHttpGetWebhooks,
  method: httpMethod.get,
  url: '/API/notifications/v1/webhooks/',

  headers,
});

/**
 * `POST /v1/webhooks/`
 *
 * Create a new webhook
 *
 * Required roles:
 *  - can_write_webhooks
 *
 * Responses
 * - 201 - Returns a created webhook
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link NotificationsWebhookSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/notifications/spec/#/default/post_v1_webhooks_}
 */
export const httpPostWebhooks = (
  body: NotificationsWebhookCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: NotificationsHttpPostWebhooks,
  method: httpMethod.post,
  url: '/API/notifications/v1/webhooks/',

  body,
  headers,
});

/**
 * `GET /v1/webhooks/{webhook_id}/`
 *
 * Get a webhook definition
 *
 * Required roles:
 *  - can_read_webhooks
 *
 * Responses
 * - 201 - Returns a webhook by it's ID
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link NotificationsWebhookSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/notifications/spec/#/default/get_v1_webhooks__webhook_id__}
 */
export const httpGetWebhooksByWebhookId = (
  webhookId: string,
  headers?: IconikApiHeaders,
) => ({
  id: NotificationsHttpGetWebhooksByWebhookId,
  method: httpMethod.get,
  url: `/API/notifications/v1/webhooks/${encodeURIComponent(webhookId)}/`,
  params: { webhookId },
  headers,
});

/**
 * `PUT /v1/webhooks/{webhook_id}/`
 *
 * Update a webhook
 *
 * Required roles:
 *  - can_write_webhooks
 *
 * Responses
 * - 200 - Returns the updated webhook
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link NotificationsWebhookSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/notifications/spec/#/default/put_v1_webhooks__webhook_id__}
 */
export const httpPutWebhooksByWebhookId = (
  webhookId: string,
  body: NotificationsWebhookCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: NotificationsHttpPutWebhooksByWebhookId,
  method: httpMethod.put,
  url: `/API/notifications/v1/webhooks/${encodeURIComponent(webhookId)}/`,
  params: { webhookId },
  body,
  headers,
});

/**
 * `DELETE /v1/webhooks/{webhook_id}/`
 *
 * Delete a webhook
 *
 * Required roles:
 *  - can_delete_webhooks
 *
 * Responses
 * - 204 - Returns an empty body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/notifications/spec/#/default/delete_v1_webhooks__webhook_id__}
 */
export const httpDeleteWebhooksByWebhookId = (
  webhookId: string,
  headers?: IconikApiHeaders,
) => ({
  id: NotificationsHttpDeleteWebhooksByWebhookId,
  method: httpMethod.delete,
  url: `/API/notifications/v1/webhooks/${encodeURIComponent(webhookId)}/`,
  params: { webhookId },
  headers,
});
